module.exports = __webpack_public_path__ + "img/shoot_00039.da4aae2a.png";